import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiurl } from '../Constants';

// Async thunk to fetch videos from the API
export const fetchVideos = createAsyncThunk('videos/fetchVideos', async () => {
  const response = await axios.get(apiurl + 'homevideos');
  return response.data.data;
});

const videoSlice = createSlice({
  name: 'videos',
  initialState: {
    videos: [],
    loading:false,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideos.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.videos = action.payload;
      })
      .addCase(fetchVideos.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default videoSlice.reducer;
